import * as React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from "react-i18next";

export default function CustomCommandCellAnimalMovements(props) {
    const { t } = useTranslation();
    return (
        <td className="k-command-cell">
            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                {props.linkToDetails && (
                    <Link to={props.linkToDetails}>
                        <button className="k-button k-button-icontext" style={{ marginLeft: "5px", marginRight: "10px" }}>
                            &nbsp;&nbsp;<span className=" k-icon k-i-pencil" title={t("Global_Label_Text_Details")}></span>  &nbsp;&nbsp;
                        </button>
                    </Link>
                )}
            </div>
        </td>
    );
}
